export default "__VITE_ASSET__CKK669dU__"